'use client'

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { VisuallyHidden } from 'radix-ui'
import AboutContent from './about-content'

export type AboutDialogProps = {
  open: boolean
  onOpenChange?: (open: boolean) => void
}

const AboutDialog = ({ open, onOpenChange }: AboutDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <VisuallyHidden.Root>
        <DialogTitle>About Benched.ai</DialogTitle>
      </VisuallyHidden.Root>
      <AboutContent onClose={() => onOpenChange?.(false)} />
    </DialogContent>
  </Dialog>
)

export default AboutDialog
